import axios from 'axios';

const packages_detailes = async (langIsoCode) => {
  try {
    const response = await axios.get(`/package-features`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });
    if (response.status === 200 && response.data.response_code === 200 && response.data.data) {
      return response.data.data;
    }
  } catch (e) {
    
  }
};

export default packages_detailes;
